<template>
  <div v-if="hasAvailableResourceTypes" class="filter-bar-wrapper d-flex flex-row align-center">
    <vs-heading class="no-shrink resource-types-title" type="overline">Resource Types</vs-heading>
    <v-divider inset vertical class="my-3 mx-6 no-shrink"></v-divider>
    <v-chip-group
      class="scrollable-chip-container"
      mandatory
      active-class="option--active"
      show-arrows="always"
      :value="value"
      @change="handleChange"
    >
      <template #prev>
        <vs-button
          data-test="resource-types-scroll-left-button"
          class="arrow--prev"
          icon="chevron_left"
          type="tertiary"
          small
        />
      </template>
      <template #next>
        <vs-button
          data-test="resource-types-scroll-right-button"
          class="arrow--next"
          icon="chevron_right"
          type="tertiary"
          small
        />
      </template>
      <v-chip
        v-for="type in selectedResourceTypeIds"
        :key="type.id"
        class="ma-2 ml-0 option"
        shrink
        color="primary"
        outlined
        pill
        :value="type.id"
      >
        {{ type.name }}
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script setup lang="ts">
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { computed } from 'vue'
import { orderBy } from 'lodash'
import { useFilteredJobStoreLegacyAdapter } from '../jobs/job-search-page/filteredJobStore'

defineProps<{ value?: number }>()
const emit = defineEmits<{ (event: 'input', value: number): void }>()

const newFilterStore = useFilteredJobStoreLegacyAdapter()

const { getActiveResourceTypes: activeResourceTypes } = createNamespacedHelpers(
  'resourceTypes',
).useGetters(['getActiveResourceTypes'])

const selectedResourceTypeIds = computed(() => {
  let filtered = activeResourceTypes.value

  if (newFilterStore.selectedResourceTypes.value.length > 0) {
    filtered = activeResourceTypes.value.filter((type) =>
      newFilterStore.selectedResourceTypes.value.includes(type.id),
    )
    return filtered
  }

  return orderBy(filtered, [(type) => type.name.toLowerCase()])
})

const hasAvailableResourceTypes = computed(() => selectedResourceTypeIds.value.length > 0)

function handleChange(value: number) {
  emit('input', value)
}
</script>

<style scoped>
.no-shrink {
  flex-shrink: 0;
}
.resource-types-title {
  font-size: 12px;
}
.scrollable-chip-container {
  width: 100%;
  overflow: hidden;
}
.arrow--prev {
  margin-left: 0px;
}
.arrow--next {
  margin-right: 0px;
}
</style>
<style>
.scrollable-chip-container .v-chip.option {
  height: 2rem !important;
  font-weight: 500 !important;
  font-family: var(--font-regular) !important;
  position: relative !important;
  color: var(--color-black) !important;
  border: thin solid var(--color-grey--lighter) !important;
  background-color: transparent !important;
}
.scrollable-chip-container .v-chip.v-chip.option:hover {
  background-color: var(--color-blue--lighter) !important;
  box-shadow: none;
}

.scrollable-chip-container .v-chip.v-chip.option:active::before,
.scrollable-chip-container .v-chip.v-chip.option:focus::before {
  color: var(--color-blue) !important;
  background-color: var(--color-blue) !important;
  box-shadow: none;
}

.scrollable-chip-container .v-chip.v-chip.option--active {
  color: var(--color-blue) !important;
}
.scrollable-chip-container .v-slide-group__prev {
  justify-content: left;
  min-width: 42px;
  position: absolute;
  height: 100%;
  background: white;
  z-index: 1;
}
.scrollable-chip-container .v-slide-group__next {
  justify-content: right;
  min-width: 42px;
}
.scrollable-chip-container .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none;
}
.scrollable-chip-container .v-slide-group__next.v-slide-group__next--disabled {
  display: none;
}
</style>
